import React from 'react';
import { css } from '@bd/bdui-styles/emotion';
import FilterBar from './FilterBar';
import AppliedFilters from './AppliedFilters';
import { colors } from '../styles';

const styles = css`
  .FilterSort_wrapper {
    position: relative;
    z-index: 10;
    background-color: ${colors.neutral};
    padding: 30px;
    overflow-y: scroll;
    &.active {
      display: block;
    }
    @media (min-width: 992px) {
      display: block;
      position: relative;
      z-index: 5;
      padding: 0;
      background-color: #FFFFFF;
      overflow-y: visible;
    }
  }
  .FilterSort_closeBtn {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 15px;
    top: 15px;
    display: block;
    background-image: url('/images/icon-close-white.svg');
    background-size: 24px 24px;
    background-position: center center;
    background-repeat: no-repeat;
    background-color: transparent;
    border: 0;
    @media (min-width: 992px) {
      display: none;
    }
  }
  .FilterSort_doneBtn {
    margin: 15px 0 0 0;
    @media (min-width: 992px) {
      display: none;
    }
  }
  .FilterSort_toggle {
    line-height: 60px;
    background-color: ${colors.brand2};
    color: #FFFFFF;
    font-size: 15px;
    font-weight: 700;
    text-align: center;
    border: 0;
    flex: 1;
    img {
      height: 20px;
      width: auto;
      margin: 0 10px 0 0;
    }
  }
  .Sort_button {
    position: relative;
    padding: 0 30px 0 15px;
    background-image: url('/images/icon-triangle-gold.svg');
    background-position: calc(100% - 12px) center;
    background-repeat: no-repeat;
    display: block;
    z-index: 2;
    cursor: pointer;
    line-height: 50px;
    background-color: #FFFFFF;
    @media (min-width: 992px) {
      position: absolute;
      padding: 0 30px 0 0;
      right: 0;
      top: 0;
    }
  }
  .Sort_buttonLabel {
    font-weight: 800;
    display: inline-block;
    @media (min-width: 992px) {
      padding: 0 0 0 30px;
      background-image: url('/images/icon-sort-gray.svg');
      background-position: left center;
      background-repeat: no-repeat;
    }
  }
  .Sort_dropdown {
    position: relative;
    list-style: none;
    padding: 0 10px;
    background: #FFFFFF;
    box-shadow: 0 10px 15px 0 rgba(0,0,0,0.50);
    background-color: ${colors.neutral};
    @media (min-width: 992px) {
      width: auto;
      position: absolute;
      min-width: 200px;
      right: 0;
    }
  }
  .Sort_dropdownItem {
    font-weight: 300;
    font-size: 14px;
    color: #3F3F3F;
    border-bottom: 1px solid #CFCFCF;
    width: 100%;
    padding: 10px 0;
    cursor: pointer;
    &:last-child {
      border: 0;
    }
    @media (min-width: 992px) {
      font-size: 16px;
    }
  }
  .Sort_dropdownItemButton {
    width: 100%;
  }
  .ResetFilter_button {
    position: absolute;
    left: 10px;
    bottom: 10px;
    vertical-align: top;
    color: ${colors.brand2};
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    @media (min-width: 992px) {
      right: 30px;
      top: 13px;
      left: auto;
    }
  }
  .ShowMap_button {
    line-height: 60px;
    background-color: ${colors.brand2};
    color: #FFFFFF;
    font-size: 15px;
    font-weight: 700;
    text-align: center;
    border: 0;
    flex: 1;
    img {
      height: 20px;
      width: auto;
      margin: 0 10px 0 0;
    }
    cursor: pointer;
  }
`;

function Filters(props) {
  return (
    <div className={styles}>
      <div className="FilterSort_wrapper">
        <FilterBar
          {...props}
        />
        <AppliedFilters
          {...props}
          clearButton={<span className="ResetFilter_button">Reset Filter <img src="/images/icon-refresh-gray.svg" alt="Reset Filters Icon" /></span>}
        />
      </div>
    </div>
  );
}

export default Filters;



// WEBPACK FOOTER //
// ./src/components/Filters.js